import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import { DxButtonModule } from 'devextreme-angular';

import {CollapseMenuComponent} from './collapse-menu/collapse-menu.component';
import {RecentProjectsComponent} from './recent-projects/recent-projects.component';
import {FullScreenComponent} from './full-screen/full-screen.component';

import {ActivitiesComponent} from './activities/activities.component';
import {ActivitiesMessageComponent} from './activities/activities-message/activities-message.component';
import {ActivitiesNotificationComponent} from './activities/activities-notification/activities-notification.component';
import {ActivitiesTaskComponent} from './activities/activities-task/activities-task.component';
import {HeaderComponent} from './header.component';
import { HubNotificationComponent } from './hubnotification/hubnotification.component';
import { HubNotificationService } from '@app/core/services/Common/hubnotification.service';
import { HealthQuotationEndpoint } from '@app/core/endpoints/health/health-quotation-endpoint.service';
import { LifeQuotationEndpoint } from '@app/core/endpoints/life/life-quotation-endpoint.service';
import {UtilsModule} from '@app/shared/utils/utils.module';
import {PipesModule} from '@app/shared/pipes/pipes.module';
import {I18nModule} from '@app/shared/i18n/i18n.module';
import {UserModule} from '@app/shared/user/user.module';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {PopoverModule} from 'ngx-bootstrap/popover';
import { CompanyInfoComponent } from './company-info/company-info.component';
import { SupportMenuComponent } from './support-menu/support-menu.component';
import { DevExtremeModule } from 'devextreme-angular';
import { AccountService } from '@app/core/services/Common/account.service';
import { AuthService } from '@app/core/services/auth/auth.service';


@NgModule({
    imports: [
        CommonModule,
        DevExtremeModule,
        FormsModule,
        // VoiceControlModule,
        BsDropdownModule,
        UtilsModule, PipesModule, I18nModule, UserModule, PopoverModule,DxButtonModule
    ],
    declarations: [
        ActivitiesMessageComponent,
        ActivitiesNotificationComponent,
        ActivitiesTaskComponent,
        RecentProjectsComponent,
        FullScreenComponent,
        CollapseMenuComponent,
        ActivitiesComponent,
        HeaderComponent,
        CompanyInfoComponent,
        SupportMenuComponent,
        HubNotificationComponent
    ],
    exports: [
        HeaderComponent,
        SupportMenuComponent,
        HubNotificationComponent
    ],
    providers: [HubNotificationService, HealthQuotationEndpoint, LifeQuotationEndpoint  ],
})
export class HeaderModule {}
